import React, {Component} from "react";

import PageContainer from "../Global/PageContainer";
import MailChimpModal from "../Global/MailChimpModal";
import {
  Margin,
  dark,
  SmallMargin,
  AttentionTitle,
  ContainWPadding,
  LargeTitle,
  MediumTitle,
  primary
} from "../Tools/Variables";
import {HeaderMargin} from "../Global/Header";

class AboutComponent extends Component {
  componentDidMount() {
    document.title = "Justerbar premiumsäng, det vi behövde. | Modilect";
  }

  render() {
    return (

      <PageContainer headerBG setShowContactModal={this.props.setShowContactModal}>
        <MailChimpModal
          showContactModal={this.props.showContactModal}
          setHideContactModal={this.props.setHideContactModal}
          setShowContactModal={this.props.setShowContactModal}/>
        <HeaderMargin/>

        <Margin/>

        <AttentionTitle
          style={{
          width: '100%',
          textAlign: 'center',
          margin: '5vh auto',
          fontSize: '7vh',
          lineHeight: '6vh'
        }}>

          om
          <SmallMargin/>
          oss
        </AttentionTitle>
        <h3
          style={{
          fontSize: 15,
          textTransform: 'uppercase',
          fontWeight: '500',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          MODILECT</h3>
        <h1
          style={{
          fontSize: 15,
          textTransform: 'uppercase',
          fontWeight: '500',
          margin: '0 auto',
          textAlign: 'center'
        }}>
          Justerbar premiumsäng</h1>

        <SmallMargin/>
        <SmallMargin/>
        <SmallMargin/>

        <ContainWPadding style={{
          maxWidth: 600
        }}>

          <span
            style={{
            fontSize: '50px',
            marginRight: '-8px',
            lineHeight: '45px'
          }}>V</span>i
          har en bakgrund inom flyg- respektive läkemedelsbranschen (jaktpilot,
          flygkapten, kvalitetsingenjör). Med kvalitets- och innovationskrav från våra
          tidigare branscher vill vi revolutionera sängtillverkningen.
          <Margin/>
          <MediumTitle style={{
            textAlign: 'center'
          }}>

            "Vi vill bygga värdens komfortablaste premiumsäng med innovativa lösningar. Endast
            det bästa är gott nog."
          </MediumTitle>
          <Margin/>

          Efter flera egna sängköp kan vi konstatera att vi inte lyckas få en säng med rätt fasthet trots omfattande test och välvillig hjälp av sängexperter. Vi förstår nu att det är näst intill omöjligt då din säng ändras efter en tids användning och att ditt behov är föränderligt över tiden.
          <SmallMargin/>
          Ibland vill du ha extra stöd för en värkande rygg eller extra mjukt för en ömmande axel. Du varierar sovställning, din kropp ändras och olika personer nyttjar kanske samma säng, det finns många skäl till att ha en dynamisk säng.
          <SmallMargin/>
        Vi har förstått att vi inte är själva i önskan om bättre sängkomfort. När vi testat våra prototyper har vi fått fantastiskt gensvar från brukare och erkännande från branschen. Justeringen gör du med fjärrkontroll, när du vill, hur ofta du vill. Anslut till vår sängrevolution, vi vill ha dina synpunkter och vi ger oss inte förrän du är lika nöjd som vi. 
          <SmallMargin/>
          <div
            style={{
            width: 40,
            height: 2,
            background: primary,
            margin: '0 auto'
          }}/>
        </ContainWPadding>
        <Margin/>

      </PageContainer>

    );
  }
}

class About extends Component {

  state = {
    showContactModal: false
  };

  setShowContactModal = () => {
    this.setState({showContactModal: true});
  };
  setHideContactModal = () => {
    this.setState({showContactModal: false});
  };
  render() {
    return (<AboutComponent
      showContactModal={this.state.showContactModal}
      setHideContactModal={this.setHideContactModal}
      setShowContactModal={this.setShowContactModal}/>);
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/About/About.js